import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-cleanup-eaton-map-army-box');

ai2htmlResize('#g-cleanup-palisades-map-army-box');
